import { render, staticRenderFns } from "./TrustedSenders.vue?vue&type=template&id=e41e0a8c&scoped=true&"
import script from "./TrustedSenders.vue?vue&type=script&lang=js&"
export * from "./TrustedSenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41e0a8c",
  null
  
)

export default component.exports